// Copyright (c) 2025 by Audere

import { useGetConversationPatientSnapshotQuery } from "../features/api/labelApiSlice";
import { selectCurrentUserPersistentGroupRole } from "../features/slices/authSlice";
import { useSelector } from "react-redux";

export const useConversationPatientSnapshot = (conversation_uid: string) => {
  const userGroupRole = useSelector(selectCurrentUserPersistentGroupRole);
  const {
    data: patientData,
    isLoading,
    error,
  } = useGetConversationPatientSnapshotQuery(
    {
      group: userGroupRole.group,
      conversation_uid,
    },
    {
      pollingInterval: 0, // No polling
      skipPollingIfUnfocused: true,
      refetchOnFocus: false,
      refetchOnReconnect: true,
      skip: !conversation_uid,
    }
  );

  return { patientData, isLoading, error };
};
